const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger';
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen';
const SCROLL_ZOOM_IN_TRIGGER_CLASSNAME = 'animate--zoom-in';
const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'scroll-trigger--cancel';

function onIntersection(entries, observer) {
  entries.forEach((entry, index) => {
    const element = entry.target;

    if (entry.isIntersecting) {
      if (element.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)) {
        element.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
        if (element.hasAttribute('data-cascade')) element.style.setProperty('--animation-order', index);
      }
      observer.unobserve(element);
    } else {
      element.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      element.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
    }
  });
}

function initializeScrollAnimationTrigger(rootEl = document, isDesignModeEvent = false) {
  const elements = Array.from(rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME));
  if (elements.length === 0) return;

  if (isDesignModeEvent) {
    elements.forEach((element) => element.classList.add('scroll-trigger--design-mode'));
    return;
  }

  const observer = new IntersectionObserver(onIntersection, { rootMargin: '0px 0px -50px 0px' });
  elements.forEach((element) => observer.observe(element));
}

function initializeScrollZoomAnimationTrigger() {
  const elements = Array.from(document.getElementsByClassName(SCROLL_ZOOM_IN_TRIGGER_CLASSNAME));
  elements.forEach((element) => element.style.setProperty('--zoom-in-ratio', '1'));
}

window.addEventListener('DOMContentLoaded', () => {
  initializeScrollAnimationTrigger();
  initializeScrollZoomAnimationTrigger();
});

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => initializeScrollAnimationTrigger(event.target, true));
  document.addEventListener('shopify:section:reorder', () => initializeScrollAnimationTrigger(document, true));
}
